import { GenericService } from '@/services/api/generic.service';
import { OrderConfigurationType } from '@/custom/menicon/models';

export class MeniconOrderConfigurationTypesService extends GenericService<OrderConfigurationType> {
  constructor() {
    super('menicon/v1/order-configuration-types');
  }
}
